import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useIsFullScreen = (): IGlobalStore['is_fullscreen'] => {
  return useSelector((store: IReducerStore) => store.global.is_fullscreen);
};
